module.exports = __webpack_public_path__ + "media/images/brand/logo-circular-half-2026-e47e4a20ff7bfdf497def8e532053e38.svg";